import React from 'react';
import { 
  Briefcase, 
  Target, 
  TrendingUp, 
  Rocket, 
  Zap, 
  CheckCircle, 
  FileText, 
  BarChart3,
  PieChart,
  Settings,
  Megaphone,
  MessageSquare,
  Code,
  Palette,
  Package,
  Trophy,
  Gift,
  Bell,
  Star,
  Calendar,
  Users,
  Database,
  Shield,
  Lock
} from 'lucide-react';

// Map icon names to Lucide components
export const BOARD_ICONS = {
  'briefcase': { component: Briefcase, label: 'Briefcase', color: '#4A5568' },
  'target': { component: Target, label: 'Target', color: '#E53E3E' },
  'trending': { component: TrendingUp, label: 'Trending', color: '#38B2AC' },
  'rocket': { component: Rocket, label: 'Rocket', color: '#805AD5' },
  'zap': { component: Zap, label: 'Lightning', color: '#ECC94B' },
  'check': { component: CheckCircle, label: 'Check', color: '#48BB78' },
  'file': { component: FileText, label: 'Document', color: '#4299E1' },
  'bar-chart': { component: BarChart3, label: 'Bar Chart', color: '#ED8936' },
  'pie-chart': { component: PieChart, label: 'Pie Chart', color: '#9F7AEA' },
  'settings': { component: Settings, label: 'Settings', color: '#718096' },
  'megaphone': { component: Megaphone, label: 'Marketing', color: '#F56565' },
  'message': { component: MessageSquare, label: 'Chat', color: '#4299E1' },
  'code': { component: Code, label: 'Development', color: '#319795' },
  'palette': { component: Palette, label: 'Design', color: '#D53F8C' },
  'package': { component: Package, label: 'Product', color: '#DD6B20' },
  'trophy': { component: Trophy, label: 'Achievement', color: '#ECC94B' },
  'gift': { component: Gift, label: 'Rewards', color: '#E53E3E' },
  'bell': { component: Bell, label: 'Notifications', color: '#805AD5' },
  'star': { component: Star, label: 'Favorites', color: '#ECC94B' },
  'calendar': { component: Calendar, label: 'Schedule', color: '#4299E1' },
  'users': { component: Users, label: 'Team', color: '#48BB78' },
  'database': { component: Database, label: 'Data', color: '#4A5568' },
  'shield': { component: Shield, label: 'Security', color: '#38B2AC' },
  'lock': { component: Lock, label: 'Private', color: '#718096' },
};

const BoardIcon = ({ icon = 'briefcase', size = 20, className = '' }) => {
  const iconData = BOARD_ICONS[icon] || BOARD_ICONS['briefcase'];
  const IconComponent = iconData.component;
  
  return (
    <IconComponent 
      size={size} 
      className={className}
      style={{ color: iconData.color }}
    />
  );
};

export default BoardIcon;
